var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1093 1.8907C17.255 1.03643 15.87 1.03643 15.0157 1.8907L14.0514 2.85499L17.145 5.94859L18.1093 4.9843C18.9636 4.13002 18.9636 2.74498 18.1093 1.8907Z",
    fill: "#484964"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2611 6.83247L13.1675 3.73888L6.16683 10.7396C5.65284 11.2536 5.27501 11.8875 5.0675 12.5842L4.40101 14.8216C4.3355 15.0415 4.39579 15.2797 4.55806 15.4419C4.72034 15.6042 4.95849 15.6645 5.17843 15.599L7.41584 14.9325C8.11248 14.725 8.74644 14.3472 9.26043 13.8332L16.2611 6.83247Z",
    fill: "#484964"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 4.37499C2.99429 4.37499 1.875 5.49428 1.875 6.87499V15.625C1.875 17.0057 2.99429 18.125 4.375 18.125H13.125C14.5057 18.125 15.625 17.0057 15.625 15.625V11.25C15.625 10.9048 15.3452 10.625 15 10.625C14.6548 10.625 14.375 10.9048 14.375 11.25V15.625C14.375 16.3154 13.8154 16.875 13.125 16.875H4.375C3.68464 16.875 3.125 16.3154 3.125 15.625V6.87499C3.125 6.18464 3.68464 5.62499 4.375 5.62499H8.75C9.09518 5.62499 9.375 5.34517 9.375 4.99999C9.375 4.65482 9.09518 4.37499 8.75 4.37499H4.375Z",
    fill: "#484964"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemo);
export default __webpack_public_path__ + "static/media/memo.9a111c1f35c7ceb867e0fb5ead449bf9.svg";
export { ForwardRef as ReactComponent };